import { Combine, Trash2 } from "lucide-react";
import { useFieldToolsStore } from "../stores/fieldToolsStore";
import type { DashboardField } from "../types/contract";

// Combine appears only with several fields selected. Combining one field is meaningless,
// and a disabled control here would just be noise. The merge gate itself is server-side.
export function CombineFieldsButton({
  selected,
}: {
  selected: DashboardField[];
}) {
  const setConfirmCombine = useFieldToolsStore((s) => s.setConfirmCombine);
  if (selected.length < 2) return null;
  return (
    <button
      onClick={() => setConfirmCombine(true)}
      className="flex items-center gap-1.5 rounded px-2.5 py-1.5 text-[12px] text-muted hover:bg-hover hover:text-fg"
    >
      <Combine size={13} /> Combine Fields
    </button>
  );
}

export function DeleteFieldsButton({
  selected,
}: {
  selected: DashboardField[];
}) {
  const setConfirmDelete = useFieldToolsStore((s) => s.setConfirmDelete);
  return (
    <button
      disabled={selected.length === 0}
      onClick={() => setConfirmDelete(true)}
      className="flex items-center gap-1.5 rounded px-2.5 py-1.5 text-[12px] text-red-400 hover:bg-red-400/10 disabled:opacity-40"
    >
      <Trash2 size={13} /> Delete
    </button>
  );
}
